<div class="">
    <div class="modal-content">
        <div class="modal-header mt-0">
            <h4 class="modal-title">View Contract</h4>
            <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="card" >
                <div class="card-body">
                <form>
                    <div class="row">
            <div class="col-6">
                <div class="row">
                    <div class="col-md-2">
                        <div class="mb-2">
                            <label for="" class="form-label">Product :</label>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="formVendor" class="form-label">{{product}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2">
                        <div class="mb-2">
                            <label for="" class="form-label">Vendor :</label>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="mb-2">
                            <label for="formVendor" class="form-label">{{ vendorServiceList }}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <div class="mb-2">
                            <label for="" class="form-label">Origin :</label>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="mb-2">
                            <label for="" class="form-label">{{ origin }}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <div class="mb-2">
                            <label for="" class="form-label">Centralized Contract:</label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-2">
                            <label for="" class="form-label">{{ centralizedContract }}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-6">
                <div class="row">
                    <div class="col-md-2">
                        <div class="mb-2">
                            <label for="" class="form-label">Service :</label>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="mb-2">
                            <label for="" class="form-label">{{ service }}</label>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-2">
                            <label for="" class="form-label">Contact Vendors :</label>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="mb-2">
                            <label for="" class="form-label">{{ formatedcontractVendors }}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="mb-2">
                            <label for="" class="form-label">Destination :</label>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="mb-2">
                            <label for="formVendor" class="form-label">{{destination}}</label>
                        </div>
                    </div>
                </div>
            </div>

        </div>
                </form>
            </div>
          </div>
        </div>

      </div>
    </div>